import { useEffect, useState } from 'react';
import {
    CheckCircle2, Circle, Loader2, AlertCircle, ListChecks, ChevronDown, ChevronRight
} from 'lucide-react';

function StepIcon({
    status
}) {
    if (status === 'done') return <CheckCircle2 className="h-4 w-4 text-green-600" />;
    if (status === 'running') return <Loader2 className="h-4 w-4 animate-spin text-sky-600" />;
    if (status === 'failed') return <AlertCircle className="h-4 w-4 text-red-600" />;
    return <Circle className="h-4 w-4 text-muted-foreground" />;
}

export default function BexiChecklistPanel({
    checklist
}) {
    const [collapsed, setCollapsed] = useState(false);
    const finished = !!(checklist && checklist.finish);
    // Fold it away on its own once the task is finished, so it stops crowding the chat.
    useEffect(() => {
        if (finished) setCollapsed(true);
    }, [finished]);
    if (!checklist || !Array.isArray(checklist.steps) || checklist.steps.length === 0) return null;
    const done = checklist.steps.filter((step) => step.status === 'done').length;
    return (
        <div className="border-b bg-muted/30 px-3 py-2">
            <div className="mx-auto max-w-3xl rounded-md border bg-background p-3">
                <button
                    type="button"
                    onClick={() => setCollapsed((v) => !v)}
                    className="flex w-full items-start justify-between gap-3 text-left"
                    aria-expanded={!collapsed}
                >
                    <div className="min-w-0">
                        <div className="flex items-center gap-2 text-sm font-semibold">
                            {collapsed
                                ? <ChevronRight className="h-4 w-4 shrink-0" />
                                : <ChevronDown className="h-4 w-4 shrink-0" />}
                            <ListChecks className="h-4 w-4 shrink-0" />
                            <span className="truncate">{checklist.title}</span>
                        </div>
                        {checklist.summary && !collapsed && (
                            <div className="mt-1 text-xs text-muted-foreground">{checklist.summary}</div>
                        )}
                    </div>
                    <div className="shrink-0 rounded-full border px-2 py-0.5 text-xs text-muted-foreground">
                        {done}/{checklist.steps.length}
                    </div>
                </button>
                {!collapsed && (
                <>
                <div className="mt-2 space-y-1.5">
                    {checklist.steps.map((step) => (
                        <div key={step.id} className="flex items-start gap-2 text-xs">
                            <StepIcon status={step.status} />
                            <div className="min-w-0 flex-1">
                                <div className="font-medium">{step.title}</div>
                                {(step.note || step.detail) && (
                                    <div className="text-muted-foreground">{step.note || step.detail}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {checklist.finish && (
                    <div className="mt-3 rounded-md border bg-muted/50 p-2 text-xs">
                        <div className="font-semibold">
                            {checklist.finish.status === 'done' ? 'Finished' : checklist.finish.status}
                        </div>
                        <div className="mt-1 text-muted-foreground">{checklist.finish.summary}</div>
                        {Array.isArray(checklist.finish.proof) && checklist.finish.proof.length > 0 && (
                            <ul className="mt-1 list-disc pl-4 text-muted-foreground">
                                {checklist.finish.proof.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        )}
                    </div>
                )}
                </>
                )}
            </div>
        </div>
    );
}
